import React, { useState, useEffect, useRef, useMemo } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import $ from "jquery";
import WOW from "wowjs";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Form from 'react-bootstrap/Form';
import globalVariables from "../../global-variables";
import Metatag from "../../hooks/Metatag";
import Accordion from 'react-bootstrap/Accordion';
import Pagination from 'react-bootstrap/Pagination';
import Button from "react-bootstrap/Pagination";
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import axios from "axios";
import FacultyList from "../../Components/FacultyList";

export default function GESHProject() {

  const { rtype_pagename } = useParams();
  const qs_rtype_pagename = rtype_pagename;

  const navigate = useNavigate();
  
  const [expanded, setExpanded] = useState(false);

  const txtSearchRef = useRef(null);

  const handleSearch = () => {
    const searchValue = txtSearchRef.current.value.trim();
    if (!searchValue) {
        // Optionally show an error message
        return;
    }
    navigate('/research-projects/search-result', {
        state: {
            resStr: searchValue,
            facultyId: null,
            faculty_name: null,
            sdg_id: null,
            sdg_name: null,
            focusAreaId: null,
            focusAreaName: null,
            rtype_pagename: qs_rtype_pagename
        },
    });
    txtSearchRef.current.value = '';
    setCurrentPage(1);
    setExpanded(false);
};

const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
        e.preventDefault(); // Prevent default form submission
        handleSearch();
    }
};

  //get research paging from settings table
  const [resPaging,setResPaging] = useState(null);
      
      useEffect(()=>{
          let _obj =new Object();
          _obj.setting_id = globalVariables.variables.strSetting_id
          axios.post(globalVariables.variables.strApiUrl +'/settingApi/getCompanySettingList',_obj)
          .then((response)=>{
                  setResPaging(response.data[0][0].setting_res_paging)
  
          })
      },[])
      
  const itemsPerPage = resPaging || 10; // Default to 10 if resPaging is null or undefined
  const [currentPage, setCurrentPage] = useState(1);

  // Filter states
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedFocusAreas, setSelectedFocusAreas] = useState([]);

   // Handle department filter change
   const handleDepartmentChange = (event) => {
    const { id, checked } = event.target;
    setSelectedDepartment(prev => 
      checked ? [...prev, id] : prev.filter(dep => dep !== id)
    );
    setExpanded(false)

    //reset focusarea value
    setSelectedFocusAreas([])

    //reset the current page
    setCurrentPage(1)
  };
  
  // Handle focus area filter change
  const handleFocusAreaChange = (event) => {
    const { id, checked } = event.target;
    setSelectedFocusAreas(prev => 
      checked ? [...prev, id] : prev.filter(area => area !== id)
    );
    setExpanded(false)

  //reset department value
    setSelectedDepartment([])

  //reset the current page
  setCurrentPage(1)
  };

  const [research, setResearch] = useState({
                              researchList : null,
                              researchDepartment : [],
                              researchFocusArea : []
                          });
  
  const [researchType ,setResearchType] = useState(null);

  
//get research type list
  useEffect(()=>{
    let _obj1 = new Object();
    _obj1.rtype_pagename = qs_rtype_pagename;
    axios
      .post(
        globalVariables.variables.strApiUrl + "/researchApi/researchTypeList",
        _obj1
      )
      .then((response) => {
        if (response.data === "error") {
          navigate("/error-page");
        } else {
          setResearchType(response.data[0])
        }
      });

  },[qs_rtype_pagename])

  //get research list
  useEffect(() => {
    let _obj = new Object();
    _obj.rtype_pagename = qs_rtype_pagename;
    _obj.res_status = 1;
    _obj.departments = selectedDepartment;
    _obj.focus_areas = selectedFocusAreas;
    axios
      .post(
        globalVariables.variables.strApiUrl + "/researchApi/getresearchList",
        _obj
      )
      .then((response_researchList) => {
        if (response_researchList.data === "error") {
          navigate("/error-page");
        } else {
          setResearch((prev) => ({...prev , researchList: response_researchList.data[0]}));
        }
      });
  }, [qs_rtype_pagename ,selectedDepartment , selectedFocusAreas]);

  useEffect(()=>{

    let _objDepartment = new Object();
		_objDepartment.rtype_id = researchType && researchType[0]?.rtype_id;

		axios.post(globalVariables.variables.strApiUrl + '/researchApi/getmapResearchDepartmenthavingResearch',_objDepartment)
			.then((response) => {
				setResearch((prev) => ({...prev , researchDepartment : response.data[0]}));
			});


    let _objFocusArea = new Object();
		_objFocusArea.rtype_id = researchType && researchType[0]?.rtype_id;

		axios.post(globalVariables.variables.strApiUrl + '/researchApi/getmapResearchFocusAreahavingResearch',_objFocusArea)
			.then((response) => {
				setResearch((prev) => ({...prev , researchFocusArea : response.data[0]}));
			});

  },[researchType])


  // Determine the start and end item for the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const displaystartedIndex = startIndex + 1; // Ensure it starts from at least 1
  const endIndex = Math.min(currentPage * itemsPerPage, research?.researchList?.length);
  
  
  // Calculate total pages
  const totalPages = Math.ceil(research.researchList?.length / itemsPerPage);
  
  // Determine the projects to display on the current page
  // const displayedProjects = research.researchList?.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );

  const displayedProjects = useMemo(() => {
    return research.researchList?.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  }, [research.researchList, currentPage, itemsPerPage]);
  
  //function to handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    // remove bg-header-home 
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10 ? $(".fixed-top").removeClass("bg-header-home") : $(".fixed-top").removeClass("bg-header-home")
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, [research.researchList ,currentPage])

  const [resFocusAreaList,setresFocusAreaList] = useState(null)

  useEffect(()=>{

    let _obj = new Object();
    //get focus area list
    axios.post(globalVariables.variables.strApiUrl + '/researchApi/getonlymappedResearchFocusAreaList',_obj)
    .then((response) => {
      setresFocusAreaList(response.data[0])
    });

  },[])
    
    
    // Create a hash map for focus area
    const focusAreaMap = useMemo(()=>{
      return resFocusAreaList && resFocusAreaList.reduce((map, focus_area) => {
        
        if (!map[focus_area.res_focus_ar_res_id]) {
          map[focus_area.res_focus_ar_res_id] = [];
        }
        map[focus_area.res_focus_ar_res_id].push(focus_area);
        return map;
      }, {});
    },[resFocusAreaList])
  
  return (
    <>
      <Header></Header>
      {/* MetaTag */}

    {
      researchType !== null ?
      <Metatag title={researchType[0]?.rtype_pagetitle}
        description={researchType[0]?.rtype_meta_description}
        keywords={researchType[0]?.rtype_meta_keywords}
      />
      :
      ''
    }

      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0" >
      <div className="visual-inside-big visual-container-inside">
          <Container>
            <Row className="g-md-0">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="d-inline-block align-self-end py-xl-3 p-2 text-white d-md-flex align-items-end wow fadeInUp">
                    <h1 className="fw-light text-white m-0 align-self-center me-3">
                      {researchType && researchType[0]?.rtype_name} |
                    </h1>
                    <div className="mb-1">
                      {research.researchList?.length > 0 ? 
                      `Showing ${displaystartedIndex}-${endIndex} of ${research.researchList !== null ? research.researchList?.length : ''} projects` 
                      :
                      `Showing 0-0 of ${research.researchList !== null ? research.researchList?.length : ''} projects`}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

    {/* Container */}
          {
            research.researchList !== null ?
              displayedProjects[0]?.rtype_desc != null && displayedProjects[0]?.rtype_desc != "" ?
              <Container className="mt-5">
                <Row className="g-0">
                  <Col md={12} lg={12}>
                    <div className="rounded-4 text-center ck-content">
                      <div className="pe-md-2 col-md-11 col-lg-10 mx-auto list" dangerouslySetInnerHTML={{ __html : displayedProjects[0]?.rtype_desc}}></div>
                    </div>
                  </Col>
                </Row>
              </Container >
              :
              null
            :
            null
          }

      {/* Content Panel */}
      <Container className="my-5 position-relative">
        <Row className="g-4 gx-xl-5">
          <Col md={4} lg={3} className="z-1">
            <div className="bg-white h-100">
              <div className="border-bottom border-4 border-primary rounded-4 h-100">
                <div className="bg-primary bg-opacity-10 rounded-4 py-md-4 py-3 px-4 border h-100 filter">
                <Navbar expanded={expanded} collapseonselect expand="xl" className='d-block p-0'>
                
                  <Navbar.Toggle onClick={() => setExpanded(expanded ? false : "expanded")} className="offcanvas-toggle shadow-none px-1 d-flex fw-medium w-100 d-md-none d-block" aria-controls={'offcanvas-filtermenu'}>
                    <div className="me-3">
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </div>
                    Filter Projects by
                  </Navbar.Toggle>

                  <Navbar.Offcanvas id={'offcanvas-filtermenu'} aria-labelledby={'offcanvas-filtermenu'} placement="start" responsive="md" className="px-md-0 px-4 mt-auto">
                    <Offcanvas.Header closeButton onClick={() => setExpanded(false)} className="px-0">
                      <Offcanvas.Title>
                      </Offcanvas.Title>
                    </Offcanvas.Header>
                    <div className="form-group mb-4">
                      <div className="input-group">
                        <input name="txtsearch"
                         type="text"
                          id="txtSearch"
                          ref={txtSearchRef}
                          className="form-control form-control-sm py-2 ps-3 pe-4 rounded-pill"
                          placeholder="Search"
                          onKeyDown={handleKeyDown}
                          />
                        <div className="search-btn">
                          <button id="researchBtn" className="researchBtn" onClick={handleSearch}><FaSearch /></button>
                        </div>
                      </div>
                      <span id="searcherrResearch" class="text-danger small mx-2"></span>
                    </div>
                    <h6 className="text-primary">Filter Projects by</h6>
                    <Accordion defaultActiveKey={['0', '1']} alwaysOpen>
                      {
                        research.researchFocusArea.length > 0 ?
                        <Accordion.Item eventKey="1" className="filterheader">
                          <Accordion.Header className="p-0 border-bottom">Focus Areas</Accordion.Header>
                          <Accordion.Body className="border-0 px-1 pt-2">
                            <Form>
                              <div className="mb-3">
                              {research.researchFocusArea?.map((focusArea ,index) => (
                                  <Form.Check type={'checkbox'}
                                    id={focusArea.focus_ar_id}
                                    label={`${focusArea.focus_ar_name} (${focusArea.research_count})`}
                                    onChange={handleFocusAreaChange} 
                                    key={index}
                                    checked={selectedFocusAreas.includes(focusArea.focus_ar_id)}
                                    className="mb-1 me-1"
                                     />
                                    ))}
                            </div>
                            </Form>
                          </Accordion.Body>
                        </Accordion.Item>
                        : 
                        null
                      }
                    {
                      research.researchDepartment.length > 0 ?
                      <Accordion.Item eventKey="0" className="filterheader">
                        <Accordion.Header className="p-0 border-bottom">Department</Accordion.Header>
                        <Accordion.Body className="border-0 px-1 pt-2">
                          <Form>
                            <div className="mb-3">
                            {research.researchDepartment?.map((department ,index) => (
                                <Form.Check type={'checkbox'}
                                  id={department.res_depart_id}
                                  label={`${department.res_depart_name} (${department.res_dep_count})`}
                                  className="mb-1"
                                  key={index}
                                  onChange={handleDepartmentChange} 
                                  checked={selectedDepartment.includes(department.res_depart_id)}
                                   />
                                  ))}
                                  </div>
                          </Form>
                        </Accordion.Body>
                      </Accordion.Item>
                      : 
                      null
                    }
                    </Accordion>
                  </Navbar.Offcanvas>
                  </Navbar>
                </div>
              </div>
            </div>
          </Col>
          {
            research.researchList !== null ?
              <Col md={8} lg={9} className="projectslist">
                <div className="border rounded-4 p-lg-5 p-4 h-100">
                    <div className="d-flex flex-column h-100">
                      {displayedProjects?.map((project, index) => {
                      return (
                        <div key={index}>
                          <Row className="position-relative g-3 overflow-hidden">
                            {/* <Col md={6} lg={3} className="pe-lg-4">
                              <Link to={`${globalVariables.variables.strDomainUrl}research-projects/${project.rtype_pagename}/${project.res_pagename}`}>
                                <img
                                  src={project.res_banner !== null && project.res_banner !== "" ? `${globalVariables.variables.strApiUrl}/research-banner/${project.res_banner}` : global.variables.strDomainUrl + "images/default-research-thumbnail.png"}
                                  alt={project.res_title}
                                  title={project.res_title}
                                  className="img-fluid border rounded-2 bg-white wow fadeInUp"
                                />
                              </Link>
                            </Col> */}
                            <Col md={12} lg={12}>
                              <Link to={`${globalVariables.variables.strDomainUrl}research-projects/${project.rtype_pagename}/${project.res_pagename}`} className="text-decoration-none">
                                <h6 className="lh-base text-black mb-2 wow fadeInUp">
                                  {project.res_title}
                                </h6>
                              </Link>
                              <ul className="list-group wow fadeInUp">
                                  <FacultyList res_id={project?.res_id}/>
                                  {
                                    resFocusAreaList !== null ? (
                                    <li className="list-group-item border-0 px-0 py-1">
                                      <span className="text-black fw-medium">Focus Areas:</span>
                                      {
                                      focusAreaMap[project?.res_id]?.map((focusArea, i) => (
                                        <>
                                        <span key={i}>
                                          {" "}{focusArea.focus_ar_name}
                                        </span>
                                          {i < focusAreaMap[project?.res_id]?.length - 1 && ','}
                                        </>
                                      ))
                                      }
                                    </li>
                                    )
                                    :
                                    null
                                  }
                              </ul>
                            </Col>
                          </Row>
                          {/* Only show <hr /> if not the last project in displayedProjects */}
                          {index < displayedProjects.length - 1 && <hr className="my-4" />}
                        </div>
                      );
                    })}
                      
                      {/* Pagination Controls */}
                      <Pagination className="mt-auto justify-content-center pt-4">
                        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                        {[...Array(totalPages).keys()].map((pageNumber) => (
                          <Pagination.Item
                            key={pageNumber + 1}
                            active={pageNumber + 1 === currentPage}
                            onClick={() => handlePageChange(pageNumber + 1)}
                          >
                            {pageNumber + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                      </Pagination>
                    </div>
                </div>
              </Col>
              :
              <Col md={8} lg={9} className="projectslist">
                <div className="border rounded-4 p-lg-5 p-4 h-100">
                  <Row >
                    <span className="text-center">Loading...</span>
                  </Row>
                </div>
              </Col>
          }
        </Row>
      </Container>

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={globalVariables.variables.strDomainUrl}>Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`${globalVariables.variables.strDomainUrl}research`}>Research</Breadcrumb.Item>
        <Breadcrumb.Item active>{researchType !== null ? researchType[0]?.rtype_name : ''}</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}